module.exports = __webpack_public_path__ + "img/apy_slogen.3bfa5156.png";